import { useEffect, useState } from 'react';

export function useUserAccess() {
  const [access, setAccess] = useState({
    isAdmin: false,
    isDirector: false,
    isRegionalManager: false,
    isRegional: false,         // grupo regional (gerente regional + comerciais lotados em regional)
    isAdmcen: false,           // grupo corporativo ADMCEN
    regionalScope: null,       // 'Regional Xx' | 'ALL' | null
    isUploader: false,
    isDecon: false,
    canUpload: false,
    canReadDreGlobal: false,   // visão consolidada do DRE (diretoria || DECON)
    canAccessRegional: false,  // vê o container docs-gerenciais
    canAccessAdmcen: false,    // vê o container docs-admcen
    officeLocation: null,
    displayName: null,         // nome de exibição (AD) para o header
    loading: true
  });

  useEffect(() => {
    fetch('/api/getUserProfile')
      .then(res => res.json())
      .then(data => {
        // Aceita ambos (camelCase ou lowercase) para robustez
        const isAdmin = data.isAdmin === true || data.isadmin === true;
        const isUploader = data.isUploader === true || data.isuploader === true;
        const isDirector = data.isDirector === true || data.isdirector === true;
        const isDecon = data.isDecon === true || data.isdecon === true;
        const isRegional = data.isRegional === true || data.isregional === true;
        const isAdmcen = data.isAdmcen === true || data.isadmcen === true;
        setAccess({
          isAdmin,
          isDirector,
          isRegionalManager: data.isRegionalManager === true || data.isregionalmanager === true,
          isRegional,
          isAdmcen,
          regionalScope: data.regionalScope || data.regionalscope || null,
          isUploader,
          isDecon,
          canUpload: isAdmin || isUploader,
          canReadDreGlobal: isDirector || isDecon,
          canAccessRegional: isAdmin || isDirector || isRegional,
          canAccessAdmcen: isAdmin || isAdmcen,
          officeLocation: data.officeLocation || data.officelocation,
          displayName: data.displayName || data.displayname || null,
          loading: false
        });
      })
      .catch(() => setAccess(prev => ({ ...prev, loading: false })));
  }, []);

  return access;
}

export function useAdmin() {
  const { isAdmin, loading } = useUserAccess();
  return { isAdmin, loading };
}